var exports = {
  "kL": "x805b157e--3e5a82--container",
  "yI": "x805b157e--3e5a82--container--mainpage-redesign",
  "Kk": "x805b157e--3e5a82--icon",
  "Lr": "x805b157e--3e5a82--geo-button",
  "qf": "x805b157e--3e5a82--placeholder",
  "x6": "x805b157e--3e5a82--button",
  "Zh": "x805b157e--3e5a82--button--mainpage-redesign",
  "Qq": "x805b157e--3e5a82--text",
};

module.exports = exports;
